<template>
  <v-tooltip
    top
    max-width="300px"
    content-class="text-center bg-purple"
   data-qa="transferfundslisatooltip-tooltip-o89ksf">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        :color="primaryColor"
       data-qa="transferfundslisatooltip-icon-e46rp8">
        mdi-information-outline
      </v-icon>
    </template>
    <span data-qa="transferfundslisatooltip-span-qj339c">{{ text.lisaAmountTooltipInfo }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TransferFundsLisaTooltip',
  data () {
    return {
      text: {
        lisaAmountTooltipInfo: this.$t('transferfunds.lisaAmountTooltipInfo')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-opacity: rgba($primary, 0.8);

.bg-purple {
  background-color: $primary-opacity;
}
</style>
